import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

// ============================================================================
// Detail-view signal (founder, 2026-08-09): the app-level journey banners
// (YourYearPlan, GettingStartedCard) belong ONLY on the pages a nav item
// opens — never over a detail view (a fit analysis, a university profile)
// that renders INSIDE one of those routes as page state, where the route
// alone can't tell. A detail view mounts <DetailViewMarker/>; the banners
// consult useDetailView(). Counter, not boolean — nested details are safe.
// ============================================================================

const DetailViewContext = createContext({ detailOpen: false, push: () => {}, pop: () => {} });

export function DetailViewProvider({ children }) {
    const [count, setCount] = useState(0);
    const push = useCallback(() => setCount((c) => c + 1), []);
    const pop = useCallback(() => setCount((c) => Math.max(0, c - 1)), []);
    return (
        <DetailViewContext.Provider value={{ detailOpen: count > 0, push, pop }}>
            {children}
        </DetailViewContext.Provider>
    );
}

export const useDetailView = () => useContext(DetailViewContext);

/** Render inside any detail view; registers for its lifetime. */
export function DetailViewMarker() {
    const { push, pop } = useDetailView();
    useEffect(() => { push(); return pop; }, [push, pop]);
    return null;
}
